import React, { useEffect, useRef, useState } from 'react';
import { MCard, MCardHead } from '../../../components/MCard/MCard';
import FiltroDashBoard from './FiltroDashboard';
import { Col, Row } from 'react-bootstrap-v5';
import { MInput } from '../../../components/MInput/MInput';
import { getAxios } from '../../../components/net';
import { API_URL } from '../../../components/MConfig';
import { fire } from '../../../../util';
import { defaultAlerts } from '../../../../_metronic/helpers';
import ChartDashBoard from './ChartDashBoard';
import { MModal } from '../../../components/MModal/MModal';
import SubGraficoModal from './SubGraficoModal';


function Dashboard() {
    //sub grafico
    const subGraficos = useRef();
    const [subGraficoData, setSubGraficoData] = useState([]);
    const [subGraficoTitle, setSubGraficoTitle] = useState('');

    //filtros
    const [indicadorMaster, setIndicadorMaster] = useState([]);
    const [gerenteIndicador, setGerenteIndicador] = useState([]);
    const [revendaIndicadora, setRevendaIndicadora] = useState([]);
    const [revendaPropria, setRevendaPropria] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [vendedores, setVendedores] = useState([]);

    //graficos
    const [graficos, setGraficos] = useState([]);

    const [data, setData] = useState({
        master: [],
        gerente: [],
        revenda: [],
        indicadora: [],
        propria: [],
        vendedor: [],
        produto: [],
    });

    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [indicadorMasterSelecionado, setIndicadorMasterSelecionado] = useState(null);
    const [GerenteIndicadorSelecionado, setGerenteIndicadorSelecionado] = useState(null);
    const [RevendaIndicadoraSelecionado, setRevendaIndicadoraSelecionado] = useState(null);
    const [RevendaPropriaSelecionado, setRevendaPropriaSelecionado] = useState(null);
    const [produtosSelecionado, setProdutosSelecionado] = useState(null);
    const [selectedCharts, setSelectedCharts] = useState([]);
    const [vendedoresSelecionado, setVendedoresSelecionado] = useState(null);
    const [tipoDeData, setTipoDeData] = useState([
        {
            "id": 0,
            "nome": "Hoje"
        },
        {
            "id": 1,
            "nome": "Últimos 7 dias"
        },
        {
            "id": 2,
            "nome": "Últimos 30 dias"
        },
        {
            "id": 3,
            "nome": "Personalizado"
        }
    ]);
    const [tipoDeDataSelecionado, setTipoDeDataSelecionado] = useState('0');

    const handleLimparFiltros = () => {
        setDataInicio('')
        setDataFim('')
        setIndicadorMasterSelecionado(null)
        setGerenteIndicadorSelecionado(null)
        setRevendaIndicadoraSelecionado(null)
        setRevendaPropriaSelecionado(null)
        setProdutosSelecionado(null)
        setVendedoresSelecionado(null)
        setTipoDeDataSelecionado('0')
    }

    const handleChangeTipoDeData = (value) => {
        const tipo = tipoDeData.find(x => x.id == value);
        if (!tipo) return;

        const hoje = new Date();
        let dataInicioFiltro = '';
        let dataFimFiltro = '';

        switch (tipo.id) {
            case 0:
                // Hoje
                dataInicioFiltro = new Date(hoje).toISOString().split('T')[0];
                dataFimFiltro = new Date().toISOString().split('T')[0];
                break;
            case 1:
                // Últimos 7 dias
                dataInicioFiltro = new Date(hoje.setDate(hoje.getDate() - 6)).toISOString().split('T')[0];
                dataFimFiltro = new Date().toISOString().split('T')[0];
                break;
            case 2:
                // Últimos 30 dias
                dataInicioFiltro = new Date(hoje.setDate(hoje.getDate() - 29)).toISOString().split('T')[0];
                dataFimFiltro = new Date().toISOString().split('T')[0];
                break;
            case 3:
                return { dataInicio, dataFim }
            default:
                return;
        }

        return { dataInicio: dataInicioFiltro, dataFim: dataFimFiltro }
    }

    const renderChart = (title, dataKey) => {
        const chartData = data[dataKey] ?? [];
        const chartMap = chartData.map(data => ({
            nome: data.nome,
            aprovado: data.aprovado,
            cancelado: data.cancelado,
            pendente: data.pendente,
            total: data.aprovado + data.cancelado + data.pendente,
            subGraficos: data.subGraficos
        }));
        return (
            <Col className='col-12' style={{ marginTop: '6rem' }}>
                <ChartDashBoard
                    data={chartMap}
                    titulo={title}
                    setSubGraficoData={setSubGraficoData}
                    setSubGraficoTitle={setSubGraficoTitle}
                    subGraficos={subGraficos}
                />
            </Col>
        );
    }
    const toggleChart = (chart) => {
        setSelectedCharts((prev) =>
            prev.includes(chart) ? prev.filter((c) => c !== chart) : [...prev, chart]
        );
    };

    const handleChangeTipoDeDataInput = (value) => {
        setTipoDeDataSelecionado(value ?? "0");
    }

    const GetFiltro = () => {

        const filtros = [
            { required: true, type: 'selectSearchNoFech', titulo: 'Data', campo: 'Data', data: tipoDeData, selecionado: tipoDeDataSelecionado, setSelecionado: handleChangeTipoDeDataInput },
        ];

        if (tipoDeDataSelecionado == '3') {
            filtros.push({ required: true, type: 'date', titulo: 'Data Inicio', campo: 'DataInicio', data: dataInicio, setSelecionado: setDataInicio })
            filtros.push({ required: true, type: 'date', titulo: 'Data Fim', campo: 'DataFim', data: dataFim, setSelecionado: setDataFim })
        }

        const cnf = JSON.parse(window.localStorage.getItem("cnf"));
        const temPermissao = cnf && (cnf.perfilId === 11 || cnf.perfilId === 12 || cnf.perfilId === 13);
        if (temPermissao) {
            filtros.push({ type: 'selectSearchNoFech', titulo: 'Indicador Master', campo: 'IndicadorMaster', data: indicadorMaster, setSelecionado: onchangeIndicadorMaster })
        }

        gerenteIndicador && gerenteIndicador.length > 0 && filtros.push({ type: 'selectSearchNoFech', titulo: 'Gerente Indicador', campo: 'GerenteIndicador', data: gerenteIndicador, selecionado: GerenteIndicadorSelecionado, setSelecionado: setGerenteIndicadorSelecionado });
        revendaIndicadora && revendaIndicadora.length > 0 && filtros.push({ type: 'selectSearchNoFech', titulo: 'Revenda Indicadora', campo: 'RevendaIndicadora', data: revendaIndicadora, selecionado: RevendaIndicadoraSelecionado, setSelecionado: setRevendaIndicadoraSelecionado });
        revendaPropria && revendaPropria.length > 0 && filtros.push({ type: 'selectSearchNoFech', titulo: 'Revenda', campo: 'RevendaPropria', data: revendaPropria, selecionado: RevendaPropriaSelecionado, setSelecionado: setRevendaPropriaSelecionado });
        vendedores && vendedores.length > 0 && filtros.push({ type: 'selectSearchNoFech', titulo: 'Vendedores', campo: 'Vendedores', data: vendedores, selecionado: vendedoresSelecionado, setSelecionado: setVendedoresSelecionado });
        produtos && produtos.length > 0 && filtros.push({ type: 'selectSearchNoFech', titulo: 'Produtos', campo: 'Produtos', data: produtos, selecionado: produtosSelecionado, setSelecionado: setProdutosSelecionado });
        

        return filtros;
    }

    const GetFilters = () => {
        getAxios().get(API_URL + "/Dashboard/filtros").then(res => {
            const { gerentes, periodos, indicadoresMasters, produtos, revendasIndicadoras, revendasProprias, vendedores } = res.data;
            setIndicadorMaster(indicadoresMasters);
            setGerenteIndicador(gerentes);
            setRevendaIndicadora(revendasIndicadoras);
            setRevendaPropria(revendasProprias);
            setProdutos(produtos);
            setVendedores(vendedores);

        });
    };

    const GetDash = (e, isClear) => {
        const data = handleChangeTipoDeData(isClear ? '0' : tipoDeDataSelecionado);
        window.showWait(true);        
        const subQuery = isClear ? "" :
            `${indicadorMasterSelecionado ? `&indicadorMasterId=${indicadorMasterSelecionado}` : ''} ${RevendaIndicadoraSelecionado ? `&revendaIndicadoraId=${RevendaIndicadoraSelecionado}` : ''}${GerenteIndicadorSelecionado ? `&gerenteIndicadorId=${GerenteIndicadorSelecionado}` : ''}${RevendaPropriaSelecionado ? `&revendaId=${RevendaPropriaSelecionado}` : ''}${produtosSelecionado ? `&produtoId=${produtosSelecionado}` : ''}${RevendaIndicadoraSelecionado ? `&revendaIndicadoraId=${RevendaIndicadoraSelecionado}` : ''}${vendedoresSelecionado ? `&vendedorId=${vendedoresSelecionado}` : ''}`
        getAxios().get(API_URL + `/Dashboard/dados-dashboard-por-filtros?dataInicio=${data.dataInicio}&dataFim=${data.dataFim}${subQuery}`
        )
            .then(res => {
                window.showWait(false);
                let { dashboard, graficos } = res.data;
                graficos = graficos.map(grafico => ({ id: grafico.id, nome: grafico.nome, key: grafico.key }));
                //setSelectedCharts([graficos.find(x => Array.isArray(dashboard[x.key]) && dashboard[x.key].length > 0)?.key]);
                setSelectedCharts(
                    graficos
                        .filter(x => Array.isArray(dashboard[x.key]) && dashboard[x.key].length > 0)
                        .map(x => x.key)
                );
                setGraficos(graficos);
                setData(dashboard);
            })
            .catch(() => {
                window.showWait(false);
            });
    };

    useEffect(() => {
        GetFilters();
        GetDash();
        fire.register('filtrar_dashboard', GetDash)
        document.querySelector('.barraNome').innerHTML = ''
    }, [])

    const handleDownloadFiltro = () => {
        window.print();
    }

    const PossuiData = () => {
        let possui = false;
        for (let index = 0; index < graficos.length; index++) {
            const grafico = graficos[index];
            if (data[grafico.key] && data[grafico.key].length > 0) {
                possui = true;
                break;
            }
        }
        return possui;
    }

    const ModalSubGrafico = () => {
        return (<SubGraficoModal
            idModal="modalSubGraficoRevenda"
            ref={subGraficos}
        >
            <ChartDashBoard
                data={subGraficoData.map(data => ({
                    nome: data.nome,
                    aprovado: data.aprovado,
                    cancelado: data.cancelado,
                    pendente: data.pendente,
                    total: data.aprovado + data.cancelado + data.pendente,
                }))}
                titulo={subGraficoTitle}
                setSubGraficoData={setSubGraficoData}
                setSubGraficoTitle={setSubGraficoTitle}
                subGraficos={subGraficos}
            />
        </SubGraficoModal>)
    }

    const onchangeIndicadorMaster = (value) => {
        setIndicadorMasterSelecionado(value)
    }

    return (
        <MCard>
            <ModalSubGrafico />
            <MCardHead title={<i className="fa fa-chart-line"> <span style={{ color: '#103452', fontFamily: 'sans-serif' }}>Dashboard de Produção</span></i>}></MCardHead>
            <h1 style={{ fontSize: 10, color: 'gray' }}>Filtros:</h1>
            <FiltroDashBoard
                handleLimparFiltro={e => { handleLimparFiltros() }}
                GetDash={GetDash}
                handleDownloadFiltro={handleDownloadFiltro}
                filtros={GetFiltro()}
            />
            <div style={{ marginTop: 25, marginBottom: '6rem' }}>
                <Row className="flex-column-reverse gap-10">
                    <Col className="col-12">
                        <Row className='flex-row gap-5'>
                            {selectedCharts.map(key => {
                                let grafico = graficos.find(x => x.key === key);
                                if (grafico) {
                                    return renderChart(grafico.nome, key);
                                }
                            })}
                        </Row>
                    </Col>
                    {graficos.length > 0 && !PossuiData() && <h1 style={{ fontSize: 10, color: 'gray' }}>Nenhum Dado Foi Encontrado...</h1>}
                    {graficos.length === 0 && <h1 style={{ fontSize: 10, color: 'gray' }}>Realiza o filtro para visualizar o DashBoard</h1>}
                    {graficos.length > 0 && <Col className="col-12">
                        {PossuiData() && <h3>Selecione para visualizar</h3>}
                        <div className="row flex flex-row">
                            {graficos.map((grafico, index) => {
                                if (data[grafico.key] && data[grafico.key].length > 0)
                                    return (
                                        <div className="col-6 col-md-3 mt-2">
                                            <MInput
                                                type="checkbox"
                                                id={`grafico-${index}`}
                                                name={`grafico-${index}`}
                                                onSelect={() => toggleChart(grafico.key)}
                                                value={grafico.nome}
                                                title={grafico.nome}
                                                checked={selectedCharts.includes(grafico.key)}
                                                key={index}
                                            />
                                        </div>
                                    )
                            })}
                        </div>
                    </Col>}
                </Row>
            </div>
        </MCard >
    );
}

export default Dashboard;